module.exports = __webpack_public_path__ + "img/team1.248c16af.webp";